<template>
  <v-container>
    <v-flex offset-md1 md10 style="text-align:center;">
      <h1>Pagina em construção</h1>
    </v-flex>
  </v-container>
</template>

<script>
export default {
  name: 'POrcamentos',
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// index.vue?cc69ead0